<template>

    <v-card >
        <v-card-title>{{$t('simulacion.modulo.peajes.titulo')}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-row>
                <v-col cols="4" sm="3">
                  <!-- Select de paises, de momento deshabilitado hasta que se asignen nuevos paises -->
                    <v-select
                    density="compact"  
                      variant="outlined" 
                      disabled=True 
                      v-model="pais_selec" 
                      :items="countries"
                      item-value="ID"
                      item-title="Name"
                      :label="$t('simulacion.modulo.peajes.selec_pais')"
                      @update:modelValue="handleFirstSelectChange"   >

                    </v-select>
                    <v-switch
                    v-model.number="local_peajes.usar_cargos"
                    :label="$t('simulacion.modulo.peajes.switch_1')"
                    :true-value="1"
                    :false-value="0"
                    inset hide-details color="blue" track-color="grey"
                  />
                   
                </v-col>
                <v-col cols="4" sm="3">
                <v-select
                    density="compact"  
                      variant="outlined" 
                         
                      v-model="tarifa_Selec" 
                      :items="grupo_tarifario"
                      item-value="ID"
                      item-title="Name"
                      :label="$t('simulacion.modulo.peajes.selec_tarif')"
                      @update:modelValue="refrescarFiltradoTarifa"

                        >

                    </v-select>

                    <v-switch
                    v-model.number="local_conf_costes.usar_passthrough"
                    :label="$t('simulacion.modulo.peajes.switch_2')"
                    :true-value="1"
                    :false-value="0"
                    inset hide-details color="blue" track-color="grey"
                  />
                    
                </v-col>
                
              <v-col v-if="false" cols="4" md="3">
                <v-text-field
                v-if="false"
                  density="compact"  
                  variant="outlined"
                  v-model="inflacion_inicial_formatted"
                  :label="$t('simulacion.modulo.peajes.inflacion_inicial')"
                  type="number"
                  step="0.1"
                  min="0"
                  @input="emitirCambio"
                />  
              </v-col>

              <v-col cols="4" md="3">
                <v-text-field
                  density="compact"  
                  variant="outlined"
                  v-model="subida_anual_formatted"
                  :label="$t('simulacion.modulo.peajes.subida_anual')"
                  
                  step="0.1"
                  min="0"
                  @input="emitirCambio"
                />
                <v-text-field
                class="pt-2"
                v-if="local_conf_costes.usar_passthrough==0"
                  density="compact"  
                  variant="outlined"
                  v-model="passthrough_inic"
                  :label="$t('simulacion.modulo.peajes.valor_inicial_passthrough')"
                  
                  step="0.1"
                  min="0"
                  @input="emitirCambio"
                />
              </v-col>

            </v-row>

            <!-- Peajes -->
            <v-row class="pa-4">
                <div class="text-h6">{{ this.$t('simulacion.modulo.peajes.termino_p') }} {{ new Date().getFullYear() }}</div>
                </v-row>
                <v-row class="pa-4">
                  <v-table class="elevation-2 custom-table">
                    <thead class="table-header">
                      <tr>
                        <th class="table-header-cell">{{ this.$t('simulacion.modulo.peajes.tipo') }}</th>
                        <th
                          v-for="columna in columns_v"
                          :key="columna.value"
                          class="table-header-cell"
                        >
                          {{ columna.text }}
                        </th>
                      </tr>
                    </thead>
                    <tbody class="table-body">
                  
                      <tr
                        v-for="(item, index) in tarifas_elec_p"
                        :key="index"
                        class="table-row"
                      >
                      <td class="table-cell negrita">
                        {{ this.$t('simulacion.modulo.peajes.energia') }}
                      </td>
                        <td
                          v-for="columna in columns_v"
                          :key="columna.value"
                          class="table-cell"
                        >
                          {{ formatNumber(item[columna.prop]) }}

                        </td>
                      </tr>

                      <tr v-for="(item, index) in tarifas_pot_p" 
                        :key="index" 
                        class="table-row">

                      <td class="table-cell negrita">
                        {{ this.$t('simulacion.modulo.peajes.potencia') }}
                      </td>
                            <td v-for="columna in columns_v" 
                            :key="columna.value" 
                            class="table-cell">
                                {{ formatNumber(item[columna.prop]) }}

                            </td>
                        </tr>


                    </tbody>
                  </v-table>
                </v-row>
            <v-divider></v-divider>

            <!-- CARGOS  -->

            <v-row class="pa-4 mt-5">
                <div class="text-h6">{{ this.$t('simulacion.modulo.peajes.termino_c') }} {{ new Date().getFullYear() }} </div>
               
            </v-row>
            <v-row class="pa-4">
                <v-table  class="elevation-2 custom-table"  :class="{ 'disabled-table': !local_peajes.usar_cargos }" >
                    <thead class="table-header">
                        <tr>
                        <th class="table-header-cell">{{ this.$t('simulacion.modulo.peajes.tipo') }}</th>
                        <th v-for="columna in columns_v" 
                        :key="columna.value"
                        class="table-header-cell">
                            {{ columna.text }}
                        </th>
                        </tr>
                    </thead>
                    <tbody  class="table-body">
                        <tr v-for="(item, index) in tarifas_elec_c" 
                        :key="index" 
                        class="table-row">
                        <td class="table-cell negrita">
                          {{ this.$t('simulacion.modulo.peajes.energia') }}
                      </td>
                            <td v-for="columna in columns_v" 
                            :key="columna.value" 
                            class="table-cell">
                                {{ formatNumber(item[columna.prop]) }}

                            </td>
                        </tr>

                        <tr v-for="(item, index) in tarifas_pot_c" 
                        :key="index" 
                        class="table-row">
                        <td class="table-cell negrita">
                          {{ this.$t('simulacion.modulo.peajes.potencia') }}
                      </td>
                            <td v-for="columna in columns_v" 
                            :key="columna.value" 
                            class="table-cell">
                                {{ formatNumber(item[columna.prop]) }}

                            </td>
                        </tr>
                    </tbody>
                </v-table>
            </v-row>

           
            
        </v-card-text>
    </v-card>


</template>

<script>
import axios from "axios";
import store from "@/store";

export default {
  props: {
    peajes: { type: Object, required: true },
    conf_costes: { type: Object, required: true },
  },

  data() {
    return {
      valid: false,
      local_peajes: { ...this.peajes },
      local_conf_costes: { ...this.conf_costes },

      loading: false,
      mensaje_loading: "",

      pais_selec: 1,
      countries: [
        { ID: 1, Name: this.$t("simulacion.modulo.peajes.country_esp") },
        { ID: 2, Name: this.$t("simulacion.modulo.peajes.country_pt") },
      ],

      tarifa_Selec: 3,
      grupo_tarifario: [
        { ID: 1, Name: "2.0TD" },
        { ID: 2, Name: "3.0TD" },
        { ID: 3, Name: "6.1TD" },
        { ID: 4, Name: "6.2TD" },
        { ID: 5, Name: "6.3TD" },
        { ID: 6, Name: "6.4TD" },
      ],

      columns_v: [
        { text: "1", prop: "t1", value: "1", key: "1" },
        { text: "2", prop: "t2", value: "2", key: "2" },
        { text: "3", prop: "t3", value: "3", key: "3" },
        { text: "4", prop: "t4", value: "4", key: "4" },
        { text: "5", prop: "t5", value: "5", key: "5" },
        { text: "6", prop: "t6", value: "6", key: "6" },
      ],

      tarifas_elec_p: [],
      tarifas_pot_p: [],
      tarifas_elec_c: [],
      tarifas_pot_c: [],

      inflacion_inicial: this.peajes.inflacion_inicial || 0,
      subida_anual: this.peajes.subida_anual || 0,

      anio_tarifario: null,
      PeajeTene: [],
      PeajeTpot: [],
      CargoTene: [],
      CargoTpot: [],
    };
  },

  computed: {
    tienePeajesRaw() {
    return (
      (this.PeajeTene?.length ?? 0) > 0 ||
      (this.PeajeTpot?.length ?? 0) > 0 ||
      (this.CargoTene?.length ?? 0) > 0 ||
      (this.CargoTpot?.length ?? 0) > 0
    );
  },
    tienePeajesGuardados() {
      const ep = this.local_peajes?.energia_p;
      const pp = this.local_peajes?.potencia_p;
      return !!(ep && pp && (Number(ep.t1) || Number(pp.t1)));
    },
    passthrough_inic: {
      get() {
        return this.formatNumber(this.local_conf_costes.valor_passthrough);
      },
      set(val) {
        const numeric = String(val).replace(",", ".");
        this.local_conf_costes.valor_passthrough = isNaN(Number(numeric)) ? 0 : Number(numeric);
      },
    },

    inflacion_inicial_formatted: {
      get() {
        return this.formatNumber(this.local_peajes.inflacion_inicial);
      },
      set(val) {
        const numeric = String(val).replace(",", ".");
        this.local_peajes.inflacion_inicial = isNaN(Number(numeric)) ? 0 : Number(numeric);
      },
    },

    subida_anual_formatted: {
      get() {
        return this.formatNumber(this.local_peajes.subida_anual);
      },
      set(val) {
        const numeric = String(val).replace(",", ".");
        this.local_peajes.subida_anual = isNaN(Number(numeric)) ? 0 : Number(numeric);
      },
    },
  },

  watch: {
    peajes: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.local_peajes = { ...newVal };
        this.pais_selec = this.local_peajes?.pais ?? 1;
        this.tarifa_Selec = this.local_peajes?.tarifa ?? 3;

        if (this.tienePeajesGuardados) {
          this.pintarDesdeLocalPeajes();
        }
      },
    },
    "local_peajes.usar_cargos"() {
      this.$emit("update:peajes", this.local_peajes);
    },

    "local_peajes.tarifa"() {
      this.tarifa_Selec = this.local_peajes["tarifa"];
    },

    "local_conf_costes.usar_passthrough"() {
      this.$emit("update:conf_costes", this.local_conf_costes);
    },

    "$i18n.locale"() {
      this.countries = [
        { ID: 1, Name: this.$t("simulacion.modulo.peajes.country_esp") },
        { ID: 2, Name: this.$t("simulacion.modulo.peajes.country_pt") },
      ];
    },
  },

  methods: {
    formatNumber(value) {
      if (value === null || value === undefined || value === "") return "";
      if (typeof value !== "number") value = Number(value);
      return String(value).replace(".", ",");
    },

    paisCode() {
      return this.pais_selec === 1 ? "ES" : "PT";
    },
    resolverAnioTarifario() {
      const y = this.local_peajes?.anio_tarifario;
      const num = Number(y);
      return Number.isFinite(num) && num > 2000 ? num : new Date().getFullYear();
    },

    pintarDesdeLocalPeajes() {
      const t = this.tarifaNombre();

      const filaE = { "Grupo tarifario": t, ...this.local_peajes.energia_p };
      const filaP = { "Grupo tarifario": t, ...this.local_peajes.potencia_p };
      const filaEC = { "Grupo tarifario": t, ...this.local_peajes.energia_c };
      const filaPC = { "Grupo tarifario": t, ...this.local_peajes.potencia_c };

      this.tarifas_elec_p = [filaE];
      this.tarifas_pot_p  = [filaP];
      this.tarifas_elec_c = [filaEC];
      this.tarifas_pot_c  = [filaPC];
    },

    async obtener_cargos_peajes() {
      try {
        this.loading = true;
        this.mensaje_loading = "Cargando cargos y peajes...";

        const pais = this.paisCode();
        const anio = this.anio_tarifario;

        const response = await axios({
          method: "get",
          url: process.env.VUE_APP_API_BASE_URL + `/api/descargar-cargos-peajes/?pais=${pais}&anio=${anio}`,
          withCredentials: true,
          headers: {
            Authorization: "Bearer " + store.state.token,
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
          responseType: "json",
        });

        const data = response.data;

        console.log("CARGOS/PEAJES response:", data);

        if (!data || data.status !== "ok") {
          console.error("Backend cargos/peajes:", data?.mensaje || data);
          this.PeajeTene = [];
          this.PeajeTpot = [];
          this.CargoTene = [];
          this.CargoTpot = [];
          this.refrescarFiltradoTarifa();
          return;
        }

        this.PeajeTene = data.peaje?.energia ?? [];
        this.PeajeTpot = data.peaje?.potencia ?? [];
        this.CargoTene = data.cargo?.energia ?? [];
        this.CargoTpot = data.cargo?.potencia ?? [];

        this.refrescarFiltradoTarifa();

      } catch (error) {
        console.error("Error al obtener cargos/peajes:", error);
      } finally {
        this.loading = false;
        this.mensaje_loading = "";
      }
    },

    tarifaNombre() {
      return this.grupo_tarifario.find(x => x.ID === this.tarifa_Selec)?.Name;
    },

    async refrescarFiltradoTarifa() {
      const t = this.tarifaNombre();
      if (!t) return;

      
      if (!this.tienePeajesRaw) {
        await this.obtener_cargos_peajes(); 
      }

      const key = "Grupo tarifario";

      this.tarifas_elec_p = this.PeajeTene.filter(r => r[key] === t);
      this.tarifas_pot_p  = this.PeajeTpot.filter(r => r[key] === t);
      this.tarifas_elec_c = this.CargoTene.filter(r => r[key] === t);
      this.tarifas_pot_c  = this.CargoTpot.filter(r => r[key] === t);

      this.ActualizarPeaje();
    },



    async handleFirstSelectChange() {
      this.local_peajes["pais"] = this.pais_selec;
      await this.obtener_cargos_peajes();
      this.ActualizarPeaje();
    },

    ActualizarPeaje() {
      const vacio = { "Grupo tarifario": this.tarifaNombre(), t1:0,t2:0,t3:0,t4:0,t5:0,t6:0 };

      const copia_elec_p = this.tarifas_elec_p[0] || vacio;
      const copia_pot_p  = this.tarifas_pot_p[0]  || vacio;
      const copia_elec_c = this.tarifas_elec_c[0] || vacio;
      const copia_pot_c  = this.tarifas_pot_c[0]  || vacio;

      this.local_peajes.tarifa = this.tarifa_Selec;

      this.local_peajes.potencia_p = Object.fromEntries(
        Object.entries(copia_pot_p).filter(([key]) => key !== "Grupo tarifario")
      );
      this.local_peajes.energia_p = Object.fromEntries(
        Object.entries(copia_elec_p).filter(([key]) => key !== "Grupo tarifario")
      );
      this.local_peajes.potencia_c = Object.fromEntries(
        Object.entries(copia_pot_c).filter(([key]) => key !== "Grupo tarifario")
      );
      this.local_peajes.energia_c = Object.fromEntries(
        Object.entries(copia_elec_c).filter(([key]) => key !== "Grupo tarifario")
      );

      if (!this.local_peajes.anio_tarifario) {
        this.local_peajes.anio_tarifario = this.anio_tarifario;
      }

      this.$emit("update:peajes", this.local_peajes);
    },
  },

  async mounted() {
    this.pais_selec = this.local_peajes["pais"];
    this.tarifa_Selec = this.local_peajes["tarifa"];

        this.pais_selec   = this.local_peajes?.pais ?? 1;
      this.tarifa_Selec = this.local_peajes?.tarifa ?? 3;


      this.anio_tarifario = this.resolverAnioTarifario();


      if (this.tienePeajesGuardados) {
        this.pintarDesdeLocalPeajes();
        return;
      }

      await this.obtener_cargos_peajes();
      
      },
};
</script>


<style scoped>
.disabled-table {
  opacity: 0.5;
  /* pointer-events: none; */ /* desactiva clics y hovers */
  user-select: none;
}

.custom-table {
  border-radius: 10px;
  overflow: hidden;
}

.table-header {
  background-color: #0078D4; /* blue-grey darken-2 */
  color: white;
 
}

.table-header-cell {
  min-width: 150px;
  font-size: 16px;
  padding: 12px;
  border-right: 1px solid #ffffff;
  text-align: center !important;
}

.table-body {
  background-color:#ebeaea; /* grey lighten-4 */
}

.table-cell {
  min-width: 150px;
  font-size: 14px;
  padding: 10px;
  border-right: 1px solid #ffffff;
   text-align: center;
}
.negrita {
  font-weight: bold;
}

/* .table-row:hover {l
  background-color: #e0f7fa; // cyan
  transition: background-color 0.3s ease;
} */
</style>

